import { IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React, { useState } from 'react'
import { StyledTab, StyledTabs, TabPanel } from './StyledTab'

export default function CustomTabAndContent({ content1, content2, tab1, tab2, tab3, content3, handleClose }) {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div>
      <StyledTabs value={value} onChange={handleChange}>
        <StyledTab label={tab1} />
        <StyledTab label={tab2} />
        <StyledTab label={tab3} />
      </StyledTabs>
      {handleClose && (
        <IconButton color="inherit" onClick={handleClose} style={{ position: 'relative', top: '-80px', left: '330px' }}>
          <Close />
        </IconButton>
      )}
      <br />

      <TabPanel value={value} index={0}>
        {content1}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {content2}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {content3}
      </TabPanel>
    </div>
  )
}
